import { allowedVideoTypes } from '../consts';

export const getFileType = (file: File) => {
  if (!file) return 'unknown';
  let type = file.name.split('.').pop();
  if (type === 'jpg') type = 'jpeg';
  if (type === 'tif') type = 'tiff';
  return type;
};

export const getFileContentType = (file: File) => {
  if (!file) return 'unknown';
  if (file.type && !file.type.startsWith('image/') && !file.type.startsWith('video/')) return file.type;
  const type = getFileType(file);
  if (allowedVideoTypes.includes(type)) return `video/${type.toLowerCase()}`;
  return `image/${type.toLowerCase()}`;
};
